import React from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '../../elements/Const';

const StyledBurger = styled.button`
  display: none;
  @media (max-width: ${TABLET_WIDTH}) {
    position: absolute;
    top: 1.5rem;
    left: 5%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 1rem;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 99;

    &:focus {
      outline: none;
    }

    &:hover {
      opacity: 0.8;
    }

    div {
      width: 1.3rem;
      height: 3px;
      background: ${(props) => (props.opened === 'opened' ? 'rgba(255, 255, 255, 1)' : '#ff3535')};
      transition: all 0.3s linear;
      position: relative;
      transform-origin: 1px;

      :first-child {
        transform: ${(props) => (props.opened === 'opened' ? 'rotate(45deg)' : 'rotate(0)')};
      }

      :nth-child(2) {
        opacity: ${(props) => (props.opened === 'opened' ? '0' : '1')};
        transform: ${(props) => (props.opened === 'opened' ? 'translateX(20px)' : 'translateX(0)')};
      }

      :nth-child(3) {
        transform: ${(props) => (props.opened === 'opened' ? 'rotate(-45deg)' : 'rotate(0)')};
      }
    }
  }
`;

const HamburgerIcon = (props) => {
  const { isHambugerOpen, setIsHambugerOpen } = props;
  return (
    <StyledBurger opened={isHambugerOpen ? 'opened' : 'closed'} onClick={() => setIsHambugerOpen(!isHambugerOpen)}>
      <div />
      <div style={{ width: '0.8rem' }} />
      <div />
    </StyledBurger>
  );
};

export default HamburgerIcon;
